<template>
  <div class="import-table-top">
    <div class="flex-line">
      <SidebarOpener />

      <h1 class="text-h3 m-0 flex-1 import-table-top__title">
        {{ project.name }} <SlashIcon /> {{ $t('Import bill of quantities') }}
      </h1>
      <div class="btn-top-grid">
        <Button type="ghost" size="small" left-icon="gear" @click="openProjectSettings">
          {{ $t('Project settings') }}
        </Button>
        <Button
          type="ghost"
          size="small"
          left-icon="question-circle"
          @click.native="openSupportChat"
        >
          {{ $t('I need help') }}
        </Button>
        <Button type="secondary" size="small" left-icon="upload" @click="$emit('reupload')">
          {{ $t('Upload another file') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
  import SidebarOpener from '@/containers/top-menu/SidebarOpener';
  import SlashIcon from '@/assets/icons/slash.svg';
  import Button from '@/components/ui-v2/Button';
  import { openSupportChat } from '@/integrations';
  import ProjectSettingsModal from '@/containers/top-menu/header/project-settings/Modal';
  import { mapActions } from 'vuex';

  export default {
    name: 'ImportHeader',
    components: {
      SidebarOpener,
      SlashIcon,
      Button,
    },
    props: {
      project: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      openSupportChat,
      openProjectSettings() {
        this.openModal({
          component: ProjectSettingsModal,
          context: {
            createForm: false,
            projectId: this.project?.id,
            attributes: {
              class: 'create-tender__container',
            },
            update: () => {
              this.$emit('update');
            },
          },
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .flex-line {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
  }
  .btn-top-grid {
    display: grid;
    margin-left: 12px;
    justify-content: start;
    grid-auto-columns: 1fr;
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    grid-template-columns: auto auto auto;
    grid-template-rows: auto;
  }
  .import-table-top {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: 8px 24px;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    &__title {
      margin-left: 10px;
    }
  }
</style>
